<template>
  <div>
     <v-container>
      <v-card v-if="!$store.getters.faqFormStatus">
        <v-card-title>
          <div class="w-100 d-flex flex-row justify-content-between">
            <div>  سوالات متداول </div>
            <div>
              <v-btn
                class="mx-1 float-left"
                color="primary"
                @click.stop="openCreateOrEditDialog()"
                >   سوال متداول جدید</v-btn
              >
            </div>
          </div>
        </v-card-title>
        <v-divider> </v-divider>
        <v-card-text>
          <faq-list> </faq-list>
        </v-card-text>
      </v-card>
      <faq-form v-else> </faq-form>
    </v-container>
  </div>
</template>

<script>
import FaqForm from "../components/FaqForm.vue";
import FaqList from "../components/FAQList.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
export default {
  components: {
    FaqList,
    FaqForm
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "سوالات متداول" }]); 
  },
   methods: {
    openCreateOrEditDialog() {
      this.$store.commit("setFaqFormStatus", true);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>